import { IProduct } from './IProduct';

export interface IPrivateLabel {
    id: string;
    name: string;
    link: string;
}
export interface IProductSheet {
    sheetNumber: string;
    title: string;
    products: IProduct[];
    category: string;
    titleDe: string;
    titleEn: string;
    additionalInfoDe: string;
    additionalInfoEn: string;
    publishDate: Date;
    pdfDe: string;
    pdfEn: string;
    htmlDe: string;
    htmlEn: string;
    privateLabels: Array<IPrivateLabel>;
    pdfLinkDe: string;
    pdfLinkEn: string;
}

export const emptyProductSheetObject: IProductSheet = {
    sheetNumber: '',
    title: '',
    products: [],
    category: '',
    titleDe: '',
    titleEn: '',
    additionalInfoDe: '',
    additionalInfoEn: '',
    publishDate: new Date(),
    pdfDe: '',
    pdfEn: '',
    htmlDe: '',
    htmlEn: '',
    privateLabels: [],
    pdfLinkDe: '',
    pdfLinkEn: '',
};
